/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import Link from './Link';

import styles from '../../../styles/partials/film-title.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    alternateTitleClassName: PropTypes.string,
    titlesContainerClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    metaClassName: PropTypes.string,
    metaItemClassName: PropTypes.string,
    directorsClassName: PropTypes.string,
    extraMetaClassName: PropTypes.string,
    lengthTypeClassName: PropTypes.string,
    durationClassName: PropTypes.string,
    countriesClassName: PropTypes.string,
    url: PropTypes.string,
    isLink: PropTypes.bool,
    withCaptions: PropTypes.bool,
    onClick: PropTypes.func,
};

const defaultProps = {
    item: null,
    className: null,
    titleClassName: null,
    alternateTitleClassName: null,
    titlesContainerClassName: null,
    linkClassName: null,
    metaClassName: null,
    metaItemClassName: null,
    directorsClassName: null,
    extraMetaClassName: null,
    lengthTypeClassName: null,
    durationClassName: null,
    countriesClassName: null,
    url: null,
    isLink: false,
    withCaptions: false,
    onClick: null,
};

const FilmTitle = ({
    item,
    className,
    titleClassName,
    alternateTitleClassName,
    titlesContainerClassName,
    linkClassName,
    metaClassName,
    metaItemClassName,
    directorsClassName,
    extraMetaClassName,
    lengthTypeClassName,
    durationClassName,
    countriesClassName,
    url,
    isLink,
    withCaptions,
    onClick,
}) => {
    const {
        url: filmUrl = null,
        title = null,
        titleAlternate = null,
        directors = null,
        lengthType = null,
        countries = null,
        duration = null,
        year = null,
    } = item || {};
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.titlesContainer,
                    {
                        [titlesContainerClassName]: titlesContainerClassName,
                    },
                ])}
            >
                <h2
                    className={classNames([
                        styles.title,
                        {
                            [titleClassName]: titleClassName !== null,
                        },
                    ])}
                >
                    {isLink && (filmUrl !== null || url !== null) ? (
                        <Link
                            className={classNames([
                                styles.link,
                                {
                                    [linkClassName]: linkClassName,
                                },
                            ])}
                            href={url !== null ? url : filmUrl}
                            onClick={onClick !== null ? onClick : null}
                        >
                            {title}
                        </Link>
                    ) : (
                        title
                    )}
                </h2>

                {!isEmpty(titleAlternate) && titleAlternate !== title ? (
                    <div
                        className={classNames([
                            styles.alternateTitle,
                            {
                                [alternateTitleClassName]: alternateTitleClassName !== null,
                            },
                        ])}
                    >
                        ({titleAlternate})
                    </div>
                ) : null}
            </div>

            {directors !== null && directors.length > 0 ? (
                <div
                    className={classNames([
                        styles.meta,
                        styles.directors,
                        {
                            [metaClassName]: metaClassName !== null,
                            [directorsClassName]: directorsClassName !== null,
                        },
                    ])}
                >
                    {(directors || []).map(({ name }, idx) => (
                        <span
                            key={`${name}-${idx + 1}`}
                            className={classNames([
                                styles.metaItem,
                                {
                                    [metaItemClassName]: metaItemClassName !== null,
                                },
                            ])}
                        >
                            {name}
                        </span>
                    ))}
                </div>
            ) : null}

            <div
                className={classNames([
                    styles.meta,
                    {
                        [metaClassName]: metaClassName !== null,
                        [extraMetaClassName]: extraMetaClassName !== null,
                    },
                ])}
            >
                {year !== null ? (
                    <div
                        className={classNames([
                            styles.metaItem,
                            {
                                [metaItemClassName]: metaItemClassName !== null,
                                [lengthTypeClassName]: lengthTypeClassName !== null,
                            },
                        ])}
                    >
                        {year}
                    </div>
                ) : null}
                {lengthType !== null ? (
                    <div
                        className={classNames([
                            styles.metaItem,
                            {
                                [metaItemClassName]: metaItemClassName !== null,
                                [lengthTypeClassName]: lengthTypeClassName !== null,
                            },
                        ])}
                    >
                        {lengthType.label}
                    </div>
                ) : null}
                {duration !== null ? (
                    <div
                        className={classNames([
                            styles.metaItem,
                            {
                                [metaItemClassName]: metaItemClassName !== null,
                                [durationClassName]: durationClassName !== null,
                            },
                        ])}
                    >
                        <FormattedMessage
                            defaultMessage="{value, plural, =0 {# minute} one {# minute} other {# minutes}}"
                            description="Film duration unit"
                            values={{
                                value: Math.round(parseInt(duration, 10) / 60),
                            }}
                        />
                    </div>
                ) : null}
                {countries !== null && countries.length > 0 ? (
                    <div
                        className={classNames([
                            styles.metaItem,
                            {
                                [metaItemClassName]: metaItemClassName !== null,
                                [countriesClassName]: countriesClassName !== null,
                            },
                        ])}
                    >
                        {(countries || []).map(({ label }) => label).join(' / ')}
                    </div>
                ) : null}
                {withCaptions ? (
                    <div
                        className={classNames([
                            styles.metaItem,
                            {
                                [metaItemClassName]: metaItemClassName !== null,
                                [durationClassName]: durationClassName !== null,
                            },
                        ])}
                    >
                        <FormattedMessage defaultMessage="Subtitled" description="Film label" />
                    </div>
                ) : null}
            </div>
        </div>
    );
};
FilmTitle.propTypes = propTypes;
FilmTitle.defaultProps = defaultProps;

export default FilmTitle;
